import {
  fetchAll,
  fetchFiltered,
  addModel,
  show,
  edit
} from '@/api/model'

const state = {
  all: [],
  isLoading: false,
  modelById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const model = await show(id)
      commit('setModelById', model)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const models = await fetchAll()
      commit('setAll', models)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const models = await fetchFiltered(queriesParams)
      commit('setAll', models.rows)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addModel(data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.modelById = null
  },

  setAll (state, model) {
    state.all = model
  },

  setModelById (state, model) {
    state.modelById = {
      id: model.id,
      name: model.name,
      manufacturer: model.manufacturer,
      canLinkSimcard: model.canLinkSimcard,
      activeType: model.activeType,
      version: model.version,
      isActive: model.isActive
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
